import { render, staticRenderFns } from "./anqing.vue?vue&type=template&id=380fb7d6&scoped=true"
import script from "./anqing.vue?vue&type=script&lang=js"
export * from "./anqing.vue?vue&type=script&lang=js"
import style0 from "./anqing.vue?vue&type=style&index=0&id=380fb7d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380fb7d6",
  null
  
)

export default component.exports